import { getTicketProductForm } from './utils';

export const initialTicketState = (): TicketState => ({
  form: {
    config: {
      filters: {
        products: {
          page: 1,
          limit: 20,
          filter: [],
          orderBy: [],
        },
      },
    },
    batch: {
      pinnedProducts: [],
      selectedProducts: [],
      availableProducts: [],
      productType: 'offline',
      total: 0,
    },
    products: {
      selectedProductForm: getTicketProductForm(),
      productForms: [],
    },
  },
  activeTab: 0,
});
